var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01879 6.92041C6.23452 6.92041 6.45021 6.83829 6.61468 6.67441L11.7902 1.51463C12.1194 1.1864 12.1194 0.654241 11.7902 0.326148C11.4611 -0.0019452 10.9274 -0.00194525 10.5982 0.326148L6.0188 4.89181L1.43941 0.326307C1.11018 -0.00178665 0.576554 -0.00178669 0.247484 0.326306C-0.0819054 0.6544 -0.0819055 1.18656 0.247484 1.51479L5.42291 6.67457C5.58746 6.83848 5.80315 6.92041 6.01879 6.92041Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.7956067fe1e397e8b184adca0986dac7.svg";
export { ForwardRef as ReactComponent };